<template>
  <v-row justify="center">
    <v-dialog v-model="isOpen" persistent max-width="600">
      <v-card>
        <v-card-title class="headline">
          {{ $t("master_data.add_mutation_" + type) }}
        </v-card-title>
        <v-divider class="my-3"></v-divider>
        <v-card-text class="pt-2">
          <v-form ref="mutationForm" lazy-validation>
            <v-row>
              <v-col cols="12">
                <DatePicker
                  :value="form.date_out"
                  outlined
                  dense
                  notitle
                  @getValue="v => (form.date_out = v)"
                />
              </v-col>
              <v-col cols="12">
                <v-textarea
                  v-model="form.description"
                  :label="$t('app.description')"
                  :rules="[v => !!v || $t('app.required')]"
                  outlined
                  dense
                ></v-textarea>
              </v-col>
            </v-row>
          </v-form>

          <v-row no-gutters justify="end">
            <v-btn
              color="primary"
              outlined
              small
              class="mr-2"
              @click="closeModal('close')"
              >{{ $t("app.cancel") }}</v-btn
            >
            <v-btn
              :loading="loading"
              color="primary"
              small
              depressed
              @click="save"
              >{{ $t("app.save") }}</v-btn
            >
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { add_mutation } from "@/api/admin/master";
import DatePicker from "@/components/DatePicker";
import moment from "moment/moment";
moment.locale("id");

export default {
  props: {
    isOpen: { type: Boolean, default: false },
    type: { type: String, required: true },
    handler: Function,
    data: Array
  },
  components: { DatePicker },
  data() {
    return {
      dataMutation: "",
      loading: false,
      form: {
        type: this.type,
        id: [],
        date_out: "",
        description: ""
      }
    };
  },
  watch: {
    isOpen(newVal) {
      if (newVal) {
        this.form.date_out = "";
        this.$nextTick(() => {
          this.form.date_out = moment().format("YYYY-MM-DD");
          switch (this.type) {
            case "student":
              this.form.id = this.data.map(r => r.student);
              break;
            default:
              this.form.id = this.data.map(r => r.id);
              break;
          }
        });
      }
    }
  },
  methods: {
    closeModal(type) {
      if (this.form.description) this.$refs.mutationForm.reset();
      this.form.date_out = "";
      this.form.description = "";
      this.handler(type);
    },
    save() {
      if (this.$refs.mutationForm.validate()) {
        this.loading = true;
        add_mutation(this.form)
          .then(res => {
            if (res.data.code) {
              let msgRes = "";
              switch (this.type) {
                case "student":
                  msgRes = this.$i18n.t(
                    "master_data.student.response.success_mutation"
                  );
                  break;
                default:
                  msgRes = this.$i18n.t("master_data.success_mutation");
                  break;
              }

              this.$store.commit("CALL_SNACKBAR", {
                msg: msgRes,
                color: "success"
              });
              this.closeModal("save");
            } else {
              this.$store.commit("CALL_SNACKBAR", {
                msg: res.data.message,
                color: "error"
              });
            }
            this.loading = false;
          })
          .catch(() => (this.loading = false));
      }
    }
  }
};
</script>
